// extracted by mini-css-extract-plugin
module.exports = {"customButton":"customButton--Pujoys57","next-btn-helper":"next-btn-helper--eArjwAPV","loadingIcon":"loadingIcon--SauDE2QQ","rotate":"rotate--PkTAdHac"};